import {
  Link,
  TableCellText,
} from "@ceridianhcm/components";
import { FormatCurrency } from "../../../../common/formatting";
import { SetStateAction } from "react";
import { CommonBlockFileName, CommonBlockPayDate, CommonBlockPeriodEndDate } from "../../CommonColumnDefinition";

export const PayFileColumnsDefinitions = (setShowPayment: { (value: SetStateAction<boolean>): void; (arg0: boolean): void; }, 
  setShowRemittance: { (value: SetStateAction<boolean>): void; (arg0: boolean): void; },
    setShowGarnishment: { (value: SetStateAction<boolean>): void; (arg0: boolean): void;
   }
) => {  

  return [
    CommonBlockFileName(),
    CommonBlockPayDate(),
    CommonBlockPeriodEndDate(),
    {
      field: "payment",
      label: "Payments",
      cellTemplate: (cell: any) => {
        if(cell.rowData.payment !== '0' && cell.rowData.payment !== null) {
          return (
            <Link
              id={`name-${cell.rowData.payment}`}
              onClick={() => setShowPayment(true)}
              variant="neutral"
              testId={`name-${cell.rowData.payment}`}
            >
              <div title={cell.rowData.payment}>
                {FormatCurrency(cell.rowData.payment)}
              </div>
            </Link>
          );
        }
        else {
          return (
            <TableCellText>
              <div title={cell.rowData.payment}>
                {FormatCurrency(cell.rowData.payment)}
              </div>
            </TableCellText>
          );
        }       
      },
    },
    {
      field: "remuneration",
      label: "Remittance",
      cellTemplate: (cell: any) => {
        if(cell.rowData.remuneration !== '0' && cell.rowData.remuneration !== null) {
          return (
            <Link
              id={`name-${cell.rowData.remuneration}`}
              onClick={() => setShowRemittance(true)}
              variant="neutral"
              testId={`name-${cell.rowData.remuneration}`}
            >
              <div title={cell.rowData.remuneration}>
                {FormatCurrency(cell.rowData.remuneration)}
              </div>
            </Link>
          );
        }
        else {
          return (
            <TableCellText>
              <div title={cell.rowData.remuneration}>
                {FormatCurrency(cell.rowData.remuneration)}
              </div>
            </TableCellText>
          );
        }       
      },
    },
    {
      field: "garnishment",
      label: "Garnishment",
     
      cellTemplate: (cell: any) => {
      if(cell.rowData.garnishment !== '0' && cell.rowData.garnishment !== null) {
          return (
        <Link
	      id={`name-${cell.rowData.garnishment}`}
              onClick={() => setShowGarnishment(true)}
              variant="neutral"
              testId={`name-${cell.rowData.garnishment}`}
            >
              <div title={cell.rowData.garnishment}>
                {FormatCurrency(cell.rowData.garnishment)}
              </div>
            </Link>
          );
        }
        else {
          return (
        <TableCellText>
          <div title={cell.rowData.garnishment}>
            {FormatCurrency(cell.rowData.garnishment)}
          </div>
        </TableCellText>
      );
      }
     },
    },
    {
      field: "total",
      label: "Total",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.total}>
            {FormatCurrency(cellContext.rowData.total)}
          </div>
        </TableCellText>
      ),
    }
  ];
};
